<template>
  <v-container :class="{'pl-5':$vuetify.breakpoint.smAndUp}" class="py-0">
    <v-layout>
      <div
        @click="$router.push(url)"
        :class="{'cursor borderLeftRight': $router.currentRoute.path != url}"
        class="headline primary--text"
      >
        {{ title }}
        <span style="font-size:14px">({{ items.length }})</span>
      </div>
    </v-layout>

    <v-layout v-if="items.length == 0 && !imagesSceleton && type!='artistsSwiper'">
      <item
        class="mt-3"
        :item="{}"
        :type="type"
        index="0"
        :category="category"
        style="margin-left:224px;margin-bottom:-20px;position:relative"
      />
    </v-layout>

    <v-layout v-if="items.length == 0 && !imagesSceleton && type=='artistsSwiper'">
      <artist
        class="mt-3"
        :item="{}"
        :type="type"
        index="0"
        :category="category"
        style="margin-left:300px;margin-bottom:-20px;position:relative"
      />
    </v-layout>

    <v-layout v-if="type =='horizontalSwiper'" row wrap>
      <swiper
        class="px-5 pt-3 pb-5"
        style="margin-left:-50px; width:120%"
        ref="mySwiper"
        :class="{'arrowBounce':arrowHelper && user == null, 'padding': (user && !imagesSceleton)?true:false}"
        :options="swiperOption"
        @navigationHide="removeHelper()"
      >
        <swiper-slide v-for="(item, index) in itemsOrSqueleton" :key="index">
          <item class="mr-4" :item="item" :type="type" :index="index" :category="category"/>
        </swiper-slide>
      </swiper>
    </v-layout>

    <v-layout v-else-if="type=='artistsSwiper'" row wrap>
      <swiper
        class="px-5 pt-3 pb-5"
        :class="{'arrowBounce':arrowHelper && user == null, 'padding-artists': user?true:false}"
        style="margin-left:-50px; width:120%;"
        ref="mySwiper"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="(item, index) in itemsOrSqueleton"
          :key="index"
          class="swiper-slide-artists"
        >
          <artist class="mr-4" :index="index" :item="item" :type="type" :category="category"/>
        </swiper-slide>
      </swiper>
    </v-layout>

    <v-layout v-else-if="type=='artistsList'" class="pt-4" row wrap>
      <v-flex
        class="pt-3"
        v-for="(item, index) in itemsOrSqueleton"
        :key="index"
        xs12
        md6
        xl4
        :pr-4="$vuetify.breakpoint.smAndUp"
        pb-4
      >
        <artist class="mr-4" :item="item" :type="type" :category="category"/>
      </v-flex>
    </v-layout>

    <v-layout v-else row wrap>
      <v-flex
        class="pt-3"
        v-for="(item, index) in itemsOrSqueleton"
        :key="index"
        xs12
        sm6
        md4
        xl3
        :pr-4="$vuetify.breakpoint.smAndUp"
        pb-4
        style="cursor:pointer"
      >
        <item :item="item" :category="category"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Item from "./Item";
import Artist from "./Artist";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";

export default {
  name: "List",
  props: ["title", "url", "items", "type", "category"],
  components: {
    Item,
    Artist,
    swiper,
    swiperSlide
  },
  computed: {
    ...mapState(["user", "imagesSceleton"]),
    itemsOrSqueleton() {
      return this.imagesSceleton ? this.noItems : this.items;
    },
    arrowHelper: {
      get: function() {
        return this.$store.state.arrowHelper;
      },
      set: function(newValue) {
        this.$store.commit("setArrowHelper", newValue);
      }
    }
  },
  data() {
    return {
      noItems: [{ ok: "ok" }, { ok: "ok" }, { ok: "ok" }],
      swiperOption: {
        slidesPerView: "auto",
        freeMode: true,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        keyboard: {
          enabled: true
        },
        fadeEffect: {
          crossFade: true
        },
        on: {
          reachEnd: () => {
            // console.log("from list: ", this.category);
            // this.items.length > 0
            //   ? this.$store.dispatch("getNextItems", {
            //       category: this.category,
            //       lastItem: this.items[this.items.length - 1]
            //     })
            //   : null;
          },
          touchStart: () => {
            this.arrowHelper = false;
          }
        }
      }
    };
  }
};
</script>

<style scoped>
.padding {
  padding-left: 274px !important;
}
.padding-artists {
  padding-left: 350px !important;
}
.swiper-slide {
  width: 224px !important;
}
.swiper-slide-artists {
  width: 324px !important;
}
/*
.swiper-slide:nth-child(2n) {
  width: 230px !important;
}
.swiper-slide:nth-child(3n) {
  width: 330px !important;
} */

.cursor {
  cursor: pointer;
}

.borderLeftRight {
  display: inline-block;
  position: relative;
  color: #000;
}

.borderLeftRight::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #000;
  transform-origin: bottom right;
  transition: transform 0.4s cubic-bezier(0.86, 0, 0.07, 1);
}

.borderLeftRight:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.arrowBounce {
  color: #5778f3;
  font-size: 22px;
  position: relative;
}

.arrowBounce::after {
  animation: bounce 2s infinite;
  content: "";
  position: absolute;
  top: calc(50% - 45px);
  right: 20px;
  background: url("../assets/arrow.png") no-repeat;
  height: 55px;
  width: 55px;
  z-index: 3;
}

@keyframes bounce {
  0% {
    opacity: 0;
    transform: translateX(0px);
  }
  10% {
    opacity: 1;
    transform: translateX(0px);
  }
  90% {
    opacity: 1;
    transform: translateX(-50px);
  }
  100% {
    opacity: 0;
    transform: translateX(-50px);
  }
}
</style>
